module.exports = __webpack_public_path__ + "static/media/skincheck.ee2457b9.svg";